import React from "react";
import Header from "./Header.js";
import ParticlesBg from "./ParticlesBg.js";
import Home from "./Home.js";
import { About } from "./About.js";
import { Contact } from "./Contact.js";
import { Pricing } from "./Pricing.js";
import ReadOnly from "./ReadOnly.js";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Terms, Privacy, Disclaimers, Playground } from "./Legal.js";

export default function App() {

  return (
    <BrowserRouter>
      <div style={{ position: "relative", zIndex: 1 }}>
        <ParticlesBg />
      <div style={{ position: "relative", zIndex: 2 }}>
        <ReadOnly />
        <Header />
        <main>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/disclaimers" element={<Disclaimers />} />
            <Route path="/playground" element={<Playground />} />

          </Routes>
        </main>
        </div>
        </div>
    </BrowserRouter>
  );
}
